import {
  PULLET_INVENTORY_CREATE_FAIL,
  PULLET_INVENTORY_CREATE_REQUEST,
} from "../pullet/actionType";
import { createPullet } from "../pullet/actions";
import axios from "./utils/axios";

const fetchPulletCreate = (pullet) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PULLET_INVENTORY_CREATE_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.post("api/pullet/create/", pullet, config);
      dispatch(createPullet(data));
    } catch (error) {
      dispatch({
        type: PULLET_INVENTORY_CREATE_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchPulletCreate;
